module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 23.0116a2a1.png";